/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSynevoExamCostSummaryDto
 */
export interface GetSynevoExamCostSummaryDto {
    /**
     * Liczba badań możliwych do zlecenia do Synevo
     * @type {number}
     * @memberof GetSynevoExamCostSummaryDto
     */
    possibleCount: number;
    /**
     * Liczba już zleconych badań Synevo
     * @type {number}
     * @memberof GetSynevoExamCostSummaryDto
     */
    orderedCount: number;
    /**
     * Liczba aktualnie niezleconych badań Synevo
     * @type {number}
     * @memberof GetSynevoExamCostSummaryDto
     */
    notOrderedCount: number;
    /**
     * Suma kwot badań możliwych do zlecenia
     * @type {string}
     * @memberof GetSynevoExamCostSummaryDto
     */
    possibleAmount: string;
    /**
     * Suma kwot badań już zleconych
     * @type {string}
     * @memberof GetSynevoExamCostSummaryDto
     */
    orderedAmount: string;
    /**
     * Suma kwot badań aktualnie niezleconych
     * @type {string}
     * @memberof GetSynevoExamCostSummaryDto
     */
    notOrderedAmount: string;
}

/**
 * Check if a given object implements the GetSynevoExamCostSummaryDto interface.
 */
export function instanceOfGetSynevoExamCostSummaryDto(value: object): value is GetSynevoExamCostSummaryDto {
    if (!('possibleCount' in value) || value['possibleCount'] === undefined) return false;
    if (!('orderedCount' in value) || value['orderedCount'] === undefined) return false;
    if (!('notOrderedCount' in value) || value['notOrderedCount'] === undefined) return false;
    if (!('possibleAmount' in value) || value['possibleAmount'] === undefined) return false;
    if (!('orderedAmount' in value) || value['orderedAmount'] === undefined) return false;
    if (!('notOrderedAmount' in value) || value['notOrderedAmount'] === undefined) return false;
    return true;
}

export function GetSynevoExamCostSummaryDtoFromJSON(json: any): GetSynevoExamCostSummaryDto {
    return GetSynevoExamCostSummaryDtoFromJSONTyped(json, false);
}

export function GetSynevoExamCostSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSynevoExamCostSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'possibleCount': json['possibleCount'],
        'orderedCount': json['orderedCount'],
        'notOrderedCount': json['notOrderedCount'],
        'possibleAmount': json['possibleAmount'],
        'orderedAmount': json['orderedAmount'],
        'notOrderedAmount': json['notOrderedAmount'],
    };
}

export function GetSynevoExamCostSummaryDtoToJSON(value?: GetSynevoExamCostSummaryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'possibleCount': value['possibleCount'],
        'orderedCount': value['orderedCount'],
        'notOrderedCount': value['notOrderedCount'],
        'possibleAmount': value['possibleAmount'],
        'orderedAmount': value['orderedAmount'],
        'notOrderedAmount': value['notOrderedAmount'],
    };
}

